const typograhpy = {
    font: {
        primary: 'Overpass',
        secondary: 'Anton'
    },
    text: {
        normal: {
            fontSize: {
                xxs: '16px',
                xs: '16px',
                sm: '20px',
                md: '20px',
                lg: '20px',
                xl: '20px'
            },
            lineHeight: {
                xxs: '24px',
                xs: '24px',
                sm: '28px',
                md: '28px',
                lg: '28px',
                xl: '28px'
            },
            fontWeight: {
                xxs: '300'
            }
        },
        small: {
            fontSize: {
                xxs: '12px',
                xs: '12px',
                sm: '12px',
                md: '14px',
                lg: '16px',
                xl: '20px'
            },
            lineHeight: {
                xxs: '20px',
                xs: '20px',
                sm: '20px',
                md: '22px',
                lg: '24px',
                xl: '28px'
            }
        }
    },
    heading: {
        h1: {
            fontSize: {
                xxs: '37px',
                xs: '44px',
                sm: '50px',
                md: '68px',
                lg: '86px',
                xl: '86px'
            },
            lineHeight: {
                xxs: '95%'
            },
            fontWeight: {
                xxs: '400'
            }
        },
        h2: {
            fontSize: {
                xxs: '24px',
                xs: '24px',
                sm: '28px',
                md: '36px',
                lg: '36px',
                xl: '36px'
            },
            lineHeight: {
                xxs: '33px',
                xs: '33px',
                sm: '39px',
                md: '48px',
                lg: '48px',
                xl: '48px'
            },
            fontWeight: {
                xxs: '500'
            }
        },
        h3: {
            fontSize: {
                xxs: '20px',
                xs: '20px',
                sm: '24px',
                md: '24px',
                lg: '24px',
                xl: '24px'
            },
            lineHeight: {
                xxs: '24px',
                xs: '24px',
                sm: '28px',
                md: '28px',
                lg: '28px',
                xl: '28px'
            },
            fontWeight: {
                xxs: '700'
            }
        },
        h4: {
            fontSize: {
                xxs: '22px',
                xs: '22px',
                sm: '28px',
                md: '36px',
                lg: '44px',
                xl: '44px'
            },
            lineHeight: {
                xxs: '140%'
            },
            fontWeight: {
                xxs: '500'
            }
        },
        h5: {
            fontSize: {
                xxs: '18px',
                xs: '18px',
                sm: '22px',
                md: '28px',
                lg: '36px',
                xl: '36px'
            },
            lineHeight: {
                xxs: '140%'
            },
            fontWeight: {
                xxs: '500'
            }
        },
        h6: {
            fontSize: {
                xxs: '16px',
                xs: '16px',
                sm: '18px',
                md: '22px',
                lg: '28px',
                xl: '28px'
            },
            lineHeight: {
                xxs: '140%'
            },
            fontWeight: {
                xxs: '500'
            }
        }
    }
};

export default typograhpy;